import { RefObject } from "react";

const calculatePopoverPosition = (
  popoverRef: RefObject<HTMLDivElement>,
  popoverContentRef: RefObject<HTMLDivElement>,
) => {
  if (!popoverRef.current || !popoverContentRef.current) return undefined;

  const iconRect = popoverRef.current.getBoundingClientRect();
  const contentRect = popoverContentRef.current.getBoundingClientRect();
  const popoverHeight = Math.min(contentRect.height, window.innerHeight * 0.8);
  const popoverWidth = Math.min(contentRect.width, window.innerWidth);

  // Default below and left aligned
  let top = iconRect.bottom + 8;
  let left = iconRect.left;

  // If not enough space below, show above
  if (window.innerHeight - iconRect.bottom < popoverHeight) {
    top = iconRect.top - popoverHeight - 8;
  }
  // If not enough space right, shift left
  if (window.innerWidth - iconRect.left < popoverWidth) {
    left = iconRect.right - popoverWidth;
  }

  // Clamp to viewport
  top = Math.max(8, Math.min(top, window.innerHeight - popoverHeight - 8));
  left = Math.max(8, Math.min(left, window.innerWidth - popoverWidth - 8));

  return {
    position: "absolute",
    background: "#1f2b2f",
    top: `${top - iconRect.top}px`,
    left: `${left - iconRect.left}px`,
    zIndex: 9999,
    width: `${popoverWidth}px`,
    height: `${popoverHeight}px`,
    maxWidth: "90vw",
    maxHeight: "800px",
    overflow: "auto",
    overflowX: "hidden",
  };
};

export default calculatePopoverPosition;
